import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useModalsAndWindow } from '../../context/ModalsAndWindowContext';
import { Modal } from '@wix/design-system';
export const ModalWrapper = _ref => {
  let {
    children,
    isOpen = true,
    ...props
  } = _ref;
  const {
    hideModalOverlay
  } = useModalsAndWindow();
  if (hideModalOverlay) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  } else {
    return /*#__PURE__*/React.createElement(Modal, _extends({
      isOpen: isOpen
    }, props), children);
  }
};
//# sourceMappingURL=ModalWrapper.js.map